/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Custom_Page_CountInputs */

const en_tables_pause_reasons_custom_page_count = /** @type {(inputs: Tables_Pause_Reasons_Custom_Page_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Custom Page Count`)
};

const de_tables_pause_reasons_custom_page_count = /** @type {(inputs: Tables_Pause_Reasons_Custom_Page_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Zusatzseiten`)
};

/**
* | output |
* | --- |
* | "Reasons Custom Page Count" |
*
* @param {Tables_Pause_Reasons_Custom_Page_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_custom_page_count = /** @type {((inputs?: Tables_Pause_Reasons_Custom_Page_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Custom_Page_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_custom_page_count(inputs)
	return de_tables_pause_reasons_custom_page_count(inputs)
});